const Home = ({ useState, formData, handleChange, handleSubmit }) => {

	return (
		<main>
			<section className="hero">
				<div className="content">
					<h2>Discover the World with a Tailored Halal Experience <img src={require('../assets/moon.png')} alt="Moon" /></h2>
					<p>Planning a trip can be overwhelming, but not when it’s made just for you. Choose your destination, set your budget, and we’ll create a personalized halal itinerary that ensures your journey is both memorable and aligned with your values.</p>
					<form className="trip-form" onSubmit={handleSubmit}>
						<div className="form-group">
							<img src={require('../assets/sign-alt.png')} alt="Destination" />
							<div>
								<label htmlFor="destination">Destination</label>
								<input type="text" id="destination" name="destination" value={formData.destination} onChange={handleChange} placeholder="Singapore" required />
							</div>
						</div>
						<div className="form-group">
							<img src={require('../assets/money-withdrawal.png')} alt="Destination" />
							<div>
								<label htmlFor="budget">Travel Budget</label>
								<div className="curr">
									<input type="number" id="budget" name="budget" value={formData.budget} onChange={handleChange} placeholder="5000000" required />
								</div>
							</div>
						</div>
						<div className="form-group">
							<img src={require('../assets/brightness-low.png')} alt="Destination" />
							<div>
								<label htmlFor="length">Length of Stay</label>
								<div className="day">
									<input type="number" id="length" name="length" value={formData.length} onChange={handleChange} placeholder="5" required />
								</div>
							</div>
						</div>
						<div className="form-group">
							<img src={require('../assets/user-circle.png')} alt="Destination" />
							<div>
								<label htmlFor="who">Who</label>
								<div className="person">
									<input type="number" id="who" name="person" value={formData.person} onChange={handleChange} placeholder="2" required />
								</div>
							</div>
						</div>
						<button className="btn-grad" type="submit">Show Me My Adventure!</button>
					</form>
				</div>
			</section>
		</main>
	);
};

export default Home;